module.exports = __webpack_public_path__ + "images/chat.svg?4fd56f3dc868a773694e353265af8194";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chat.svg
// module id = 355
// module chunks = 0